import React from 'react';
import Radium from 'radium';

import { connectMotion } from 'shared/kanimate';
import { StylePropType } from 'globals/styles';

import { start, end, tween, staticStyles } from './styles';
import ChatConversationHeaderInfo from '../ChatConversationHeaderInfo';
import ChatConversationHeaderMenuButton from '../ChatConversationHeaderMenuButton';

export const ChatConversationHeader = props => {
  const { styles, onCloseClick, expanded, hasAgent, showOrgAvatar } = props;
  return (
    <div key="wrapper" style={styles.wrapper} className="kustomer-app-header">
      <ChatConversationHeaderMenuButton />
      <ChatConversationHeaderInfo expanded={expanded} team={!hasAgent} showOrgAvatar={showOrgAvatar} />
      <div style={styles.close.wrapper} onClick={onCloseClick} className="kustomer-app-header-close-button">
        <div style={styles.close.icon} />
      </div>
    </div>
  );
};

ChatConversationHeader.propTypes = {
  onCloseClick: React.PropTypes.func,
  expanded: React.PropTypes.bool,
  showOrgAvatar: React.PropTypes.bool,
  hasAgent: React.PropTypes.bool,
  styles: StylePropType,
};

ChatConversationHeader.defaultProps = {
  onCloseClick: () => {},
  expanded: true,
  showOrgAvatar: false,
  hasAgent: false,
  team: true,
  styles: {
    menu: {},
    close: {},
  },
};

const styleProps = {
  styles: staticStyles,
  start,
  end,
  tween,
};

export const RadiumChatConvoHeader = Radium(ChatConversationHeader);
export default connectMotion(styleProps)(ChatConversationHeader);
